import { css } from 'emotion';

export const wrapperStyle = css({
	width: '100%',
});



// WEBPACK FOOTER //
// ./src/layouts/index.styles.js